import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 212,
	height: 157,
	viewBox: "0 0 212 157",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M41.3721 58.0903C41.3721 56.9858 42.2675 56.0903 43.3721 56.0903H45.3135C45.8392 56.0903 46.3437 56.2973 46.718 56.6664L107.805 116.919C108.584 117.686 109.834 117.687 110.613 116.92L171.82 56.6651C172.195 56.2968 172.698 56.0903 173.223 56.0903H175.045C176.149 56.0903 177.045 56.9858 177.045 58.0903V147.017C177.045 148.122 176.149 149.017 175.045 149.017H43.3721C42.2675 149.017 41.3721 148.122 41.3721 147.017V58.0903Z",
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M168.091 149.019H49.0655C47.3152 149.019 46.4093 146.929 47.6055 145.652L107.339 81.8537C108.131 81.0074 109.475 81.0099 110.264 81.8591L169.556 145.657C170.745 146.937 169.838 149.019 168.091 149.019Z",
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.249 54.7181H43.1686C41.3694 54.7181 40.4852 56.9083 41.78 58.1575L108.065 122.104C108.842 122.853 110.073 122.851 110.847 122.099L176.643 58.1524C177.931 56.9009 177.045 54.7181 175.249 54.7181Z",
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.8106 34.0917L43.4539 10.2422M34.4364 40.5244L18.4386 20.1862M25.9948 51.3114L2.77752 42.2377",
			stroke: "#F385FF",
			strokeWidth: 3,
			strokeLinecap: "square"
		})
	]
});
export default SvgEmail;
